import React, { useState, useContext } from "react";
import { postReq } from "./middleware/AxiosApisCall";
import AuthContext from "../Context/AuthContext";
import { SuccessAlert } from "./middleware/AlertMsg";
import { ErrorAlert } from "./middleware/AlertMsg";
import { useCookies } from "react-cookie";
import { FaEyeSlash, FaEye } from "react-icons/fa";

function Login() {
  const path = "Login";
  const [inputs, setInputs] = useState({});
  const [cookies, setCookie] = useCookies(["user"]);
  const { setIsLoggedIn } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);
  const [wrong, setWrong] = useState(false);
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await postReq(path, inputs);
    
      if (response.success) {
        // console.log('Response:',response);
        localStorage.setItem("username", response.data.username);
        setCookie("JWTcookie", response.data.token, { path: "/" });
        setIsLoggedIn(true);
        SuccessAlert({
          title: "Login",
          message: "Login successfully",
        });
      } else {
        setWrong(true);
        ErrorAlert({
          title: "Login Fail",
          message: `${response.msg} Fail`,
        });
      }
    } catch (error) {
      // console.log("error: ", error);
        return  ErrorAlert({
          title: 'Login Fail',
          message: `Network Error 404`
        })
      }
      
    }
  
  return (
    <>
      <div className="loginbody">
        <div className="loginbox">
          <img src="snaxsmart.png" className="cicon" alt="image not found"/>
          <h3 className="signinhere">Sign In Here</h3>
          {wrong ? (<div style={{ color: 'white', padding: '3px', marginBottom: '13px', backgroundColor: 'red' }} >Wrong User-ID or Password </div>) : ''}
          <form onSubmit={handleSubmit}>
            <div className="inputdiv">
              <input
                type="text"
                name="user_id"
                value={inputs.user_id || ""}
                onChange={handleChange}
                placeholder="User ID"
                required
                autoComplete="off"
              />
            </div>
            <div className="inputdiv">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={inputs.password || ""}
                onChange={handleChange}
                placeholder="User password"
                required
                autoComplete="off"
              />
              <span className="showicon" onClick={handleTogglePassword}>
                {showPassword ? (
                  <FaEyeSlash className="eyeicon" />
                ) : (
                  <FaEye className="eyeicon" />
                )}
              </span>
            </div>

            <input type="submit" value="Login" />
          </form>
          <a href="password" className="forgot">
            Forgot Password
          </a>
        </div>
      </div>
    </>
  );
}

export default Login;
